import threeArrowsComp from '../components/three-arrows-comp'
export default {
  components: {
    threeArrowsComp
  },
  data(){
    return {
      isHover: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/includes/LinkToProjectCool.js